import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'
import { useRetroMode } from '../../context/RetroModeContext'
import RetroToggle from '../retroToggle/RetroToggle'
import Logo from '../logo/Logo'

const COUNTER_KEY = 'retroVisitorCount'

const useVisitorCount = (active) => {
  const [count, setCount] = useState(null)

  useEffect(() => {
    if (!active) return undefined
    const current = Number(window.localStorage.getItem(COUNTER_KEY)) || 0
    const next = current + 1
    window.localStorage.setItem(COUNTER_KEY, String(next))
    setCount(next)
    return undefined
  }, [active])

  return count
}

const Footer = () => {
  const { retroMode } = useRetroMode()
  const visitorCount = useVisitorCount(retroMode)

  return (
    <footer>
      <Logo className="footer-logo" />
      <p className="copyright">
        © {new Date().getFullYear()} Jarder Silva  Feito com{' '}
        <span role="img" aria-label="coração">
          💜
        </span>{' '}
        e React
      </p>
      {retroMode && (
        <div className="retro-footer-extra">
          <div className="retro-visitor-counter">
            Você é o visitante nº {String(visitorCount || 0).padStart(6, '0')}
          </div>
          <div className="retro-badge">
            <span role="img" aria-label="computador">
              💻
            </span>{' '}
            Melhor visualizado em 800x600
            <br />
            no Internet Explorer
          </div>
        </div>
      )}
      <Link to="/ferramentas" className="footer-tools-link">
        <span role="img" aria-label="ferramentas">
          🛠️
        </span>{' '}
        Ferramentas gratuitas
      </Link>
      <Link to="/privacidade" className="footer-privacy-link">
        Política de Privacidade
      </Link>
      <RetroToggle />
    </footer>
  )
}

export default Footer
